import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppApi } from '../../../shared/services/app-api';

@Injectable()
export class SolarPanelService {
  constructor(
    private http: HttpClient
  ) { }

  addSolarPanelQuote(data: any) {
    return this.http.post(AppApi.SOL_PANEL_QU, data);
  }
}
